function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "1D560DCD-2EE4-416C-8AEE-A4BC671D2D5E");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Permatrol",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Pagina_principal",
  transform: "translate(-978.000000, -2010.000000)",
  fill: "#EE3746",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "TERCERO",
  transform: "translate(0.000000, 1967.000000)"
}, React.createElement("g", {
  id: "Group-8",
  transform: "translate(955.000000, 25.000000)"
}, React.createElement("g", {
  id: "placeholder",
  transform: "translate(23.000000, 18.000000)"
}, React.createElement("path", {
  d: "M12.4755176,35 C12.1210059,35 11.791377,34.8167969 11.6042773,34.5152637 L1.83674805,18.7750391 C0.634990234,16.8341797 0,14.5970508 0,12.3046875 C0,5.51988281 5.51988281,0 12.3046875,0 C19.0894922,0 24.609375,5.51988281 24.609375,12.3046875 C24.609375,14.5290332 24.009248,16.7089453 22.8737988,18.6087891 L13.3552344,34.5014551 C13.1714844,34.808252 12.8411719,34.9971289 12.4836523,35 C12.480918,35 12.478252,35 12.4755176,35 Z M12.3046875,2.05078125 C6.65068359,2.05078125 2.05078125,6.65068359 2.05078125,12.3046875 C2.05078125,14.215332 2.57947266,16.079082 3.57984375,17.6945508 L12.4600684,32.0049023 L21.1139551,17.555918 C22.0588184,15.9747656 22.5585938,14.1586621 22.5585938,12.3046875 C22.5585938,6.65068359 17.9586914,2.05078125 12.3046875,2.05078125 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M12.3046875,18.4570312 C10.1584082,18.4570312 8.20011719,17.3648535 7.06624023,15.5355566 C6.46816406,14.5685449 6.15234375,13.4516211 6.15234375,12.3046875 C6.15234375,8.91228516 8.91228516,6.15234375 12.3046875,6.15234375 C15.6970898,6.15234375 18.4570312,8.91228516 18.4570312,12.3046875 C18.4570312,13.4178516 18.1582324,14.5064746 17.5930371,15.4529785 C16.4686621,17.3341602 14.4917773,18.4570312 12.3046875,18.4570312 Z M12.3046875,8.203125 C10.0430859,8.203125 8.203125,10.0430859 8.203125,12.3046875 C8.203125,13.0703125 8.41291992,13.8141992 8.80981445,14.455957 C9.56655273,15.6768555 10.8732422,16.40625 12.3046875,16.40625 C13.7632715,16.40625 15.0820605,15.6566895 15.8325098,14.4012012 C16.2078027,13.7727734 16.40625,13.0476855 16.40625,12.3046875 C16.40625,10.0430859 14.5662891,8.203125 12.3046875,8.203125 Z",
  id: "Shape"
}))))));

var SvgPlaceholder = function SvgPlaceholder(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "25px",
    height: "35px",
    viewBox: "0 0 25 35",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPlaceholder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/placeholder.921af6cf.svg";
export { ForwardRef as ReactComponent };